import React from 'react';
import Container from 'utils/Container';

const DataPrivacy = () => {
  return (
    <Container>
      <div>
        <h1 className="py-6 text-base font-semibold uppercase">DATENSCHUTZ</h1>

        <h2>1. DATENSCHUTZERKLÄRUNG</h2>

        <h3 style={{ marginTop: '0.5em', marginBottom: '1em' }}>
          1.1 DATENSCHUTZ AUF EINEN BLICK
        </h3>

        <p>
          <div>Allgemeine Hinweise</div>
          Die folgenden Hinweise geben einen einfachen Überblick darüber, was
          mit Ihren personenbezogenen Daten passiert, wenn Sie unsere Website
          besuchen. Personenbezogene Daten sind alle Daten, mit denen Sie
          persönlich identifiziert werden können.
        </p>
        <br />
        <p>
          <div>Datenerfassung auf unserer Website</div>
          Das Büro erfasst während Ihrem Besuch der Website keine eigenen Daten.
          Die Datenverarbeitung auf dieser Website erfolgt ausschließlich durch
          den Websitebetreiber. Dessen Kontaktdaten können Sie nachfolgend unter
          dem Abschnitt &apos;1.2 Hosting&apos; einsehen.
        </p>
        <br />
        <p>
          <div>Wie erfassen wir Ihre Daten?</div>
          Ihre Daten werden zum einen dadurch erhoben, dass Sie uns diese
          mitteilen. Hierbei kann es sich z.B. um Daten handeln, die Sie uns bei
          einem Kontakt per E-Mail mitteilen. Andere personenbezogene Daten
          werden automatisch beim Besuch der Website durch IT-Systeme des
          Websitebetreibers erfasst. Das sind vor allem technische Daten (z.B.
          Internetbrowser, Betriebssystem oder Uhrzeit des Seitenaufrufs). Die
          Erfassung dieser Daten erfolgt automatisch, sobald Sie unsere Website
          betreten.
        </p>
        <br />
        <p>
          <div>Wofür nutzen wir Ihre Daten?</div>
          Ein Teil der Daten wird erhoben, um eine fehlerfreie Bereitstellung
          der Website zu gewährleisten. Andere Daten können zur Analyse Ihres
          Nutzerverhaltens verwendet werden.
        </p>
        <br />
        <p>
          <div>Welche Rechte haben Sie bezüglich Ihrer Daten?</div>
          Sie haben jederzeit das Recht unentgeltlich Auskunft über Herkunft,
          Empfänger und Zweck Ihrer gespeicherten, personenbezogenen Daten zu
          erhalten. Sie haben außerdem ein Recht, die Berichtigung, Sperrung
          oder Löschung dieser Daten zu verlangen. Hierzu sowie zu weiteren
          Fragen zum Thema Datenschutz können Sie sich jederzeit unter der im
          Impressum angegebenen Adresse an uns wenden. Des Weiteren steht Ihnen
          gesetzlich ein Beschwerderecht bei der zuständigen Aufsichtsbehörde
          zu.
        </p>
        <br />
        <p>
          <div>Analyse-Tools und Tools von Drittanbietern</div>
          Beim Besuch unserer Website kann Ihr Surf-Verhalten statistisch
          ausgewertet werden. Das geschieht vor allem sogenannten
          Analyseprogrammen. Die Analyse Ihres Surf-Verhaltens erfolgt in der
          Regel anonym; das Surf-Verhalten kann nicht zu Ihnen zurückverfolgt
          werden. Sie können dieser Analyse widersprechen. Über die
          Widerspruchsmöglichkeiten werden wir Sie in dieser
          Datenschutzerklärung informieren.
        </p>

        <h3 style={{ marginTop: '2em', marginBottom: '1em' }}>1.2 HOSTING</h3>

        <p>
          <div>Externes Hosting</div>
          Ich nutze die Dienste der GitHub B.V., Prins Bernhardplein 200,
          Amsterdam 1097JB, Niederlande zum Webhosting für meine Webseite.
          Weitere Informationen erhalten Sie in der Datenschutzerklärung der
          GitHub B.V. unter
          {' https://docs.github.com/de/site-policy/privacy-policies'}.
        </p>
        <h3 style={{ marginTop: '2em', marginBottom: '1em' }}>
          1.3 DARSTELLUNG VON SCHRIFTARTEN
        </h3>

        <p>
          <div>Google Web Fonts</div>
          Ich nutze zur einheitlichen Darstellung von Schriftarten sogenannte
          Google Web Fonts, die von der Google Ireland Limited, Gordon House,
          Barrow Street, Dublin 4, Irland, bereitgestellt werden. Beim Aufruf
          meiner Webseite lädt Dein Browser die benötigten Web Fonts in Deinen
          Browsercache, um Texte und Schriftarten korrekt anzuzeigen. Wenn Dein
          Browser Web Fonts nicht unterstützt, wird eine Standardschrift von
          Deinem Computer genutzt. Weitere Informationen zu Google Web Fonts
          findest Du unter https://developers.google.com/fonts/faq und in der
          Datenschutzerklärung von Google:
          https://www.google.com/policies/privacy/. Ich kann für die
          Datenverarbeitung von Google keine Verantwortung übernehmen und habe
          abgesehen von den Informationen auf den vorgenannten Webseiten keine
          Informationen über Googles Datenverarbeitungsaktivitäten.
        </p>
        <h3 style={{ marginTop: '2em', marginBottom: '1em' }}>
          1.4 ALLGEMEINE HINWEISE UND PFLICHTINFORMATIONEN
        </h3>

        <p>
          <div>Datenschutz</div>
          Die Betreiber dieser Seiten nehmen den Schutz Ihrer persönlichen Daten
          sehr ernst. Wir behandeln Ihre personenbezogenen Daten vertraulich und
          entsprechend der gesetzlichen Datenschutzvorschriften sowie dieser
          Datenschutzerklärung. Wir weisen darauf hin, dass die Datenübertragung
          im Internet (z.B. bei der Kommunikation per E-Mail) Sicherheitslücken
          aufweisen kann. Ein lückenloser Schutz der Daten vor dem Zugriff durch
          Dritte ist nicht möglich.
        </p>
        <br />
        <p>
          Die verantwortliche Stelle für die Datenverarbeitung auf dieser
          Website ist:
          <br /> Isabelle Ihl
          <br />
          Damaschkestr. 34
          <br />
          D- 10711 Berlin
          <br />
          info@ihl-architektur.de
        </p>
        <br />
        <p>
          <div>Widerruf Ihrer Einwilligung zur Datenverarbeitung</div>
          Viele Datenverarbeitungsvorgänge sind nur mit Ihrer ausdrücklichen
          Einwilligung möglich. Sie können eine bereits erteilte Einwilligung
          jederzeit widerrufen. Dazu reicht eine formlose Mitteilung per E-Mail
          an uns. Die Rechtmäßigkeit der bis zum Widerruf erfolgten
          Datenverarbeitung bleibt vom Widerruf unberührt.
        </p>
        <br />
        <p>
          <div>Beschwerderecht bei der zuständigen Aufsichtsbehörde</div>
          Im Falle datenschutzrechtlicher Verstöße steht dem Betroffenen ein
          Beschwerderecht bei der zuständigen Aufsichtsbehörde zu. Zuständige
          Aufsichtsbehörde in datenschutzrechtlichen Fragen ist der
          Landesdatenschutzbeauftragte des Bundeslandes, in dem unser
          Unternehmen seinen Sitz hat. Eine Liste der Datenschutzbeauftragten
          sowie deren Kontaktdaten können folgendem Link entnommen werden:
          {
            ' https://www.bfdi.bund.de/DE/Infothek/AnschriftenLinks/anschriftenlinks-node.html'
          }
        </p>
        <br />
        <p>
          <div>Recht auf Datenübertragbarkeit</div>
          Sie haben das Recht, Daten, die wir auf Grundlage Ihrer Einwilligung
          oder in Erfüllung eines Vertrags automatisiert verarbeiten, an sich
          oder an einen Dritten in einem gängigen, maschinenlesbaren Format
          aushändigen zu lassen. Sofern Sie die direkte Übertragung der Daten an
          einen anderen Verantwortlichen verlangen, erfolgt dies nur, soweit es
          technisch machbar ist.
        </p>
        <br />
        <p>
          <div>SSL- bzw. TLS-Verschlüsselung</div>
          Diese Seite nutzt aus Sicherheitsgründen eine SSL- bzw.
          TLS-Verschlüsselung. Eine verschlüsselte Verbindung erkennen Sie
          daran, dass die Adresszeile des Browsers von “http://” auf “https://”
          wechselt und an dem Schloss-Symbol in Ihrer Browserzeile. Wenn die
          SSL- bzw. TLS-Verschlüsselung aktiviert ist, können die Daten, die Sie
          an uns übermitteln, nicht von Dritten mitgelesen werden.
        </p>
        <br />
        <p>
          <div>Auskunft, Sperrung, Löschung</div>
          Sie haben im Rahmen der geltenden gesetzlichen Bestimmungen jederzeit
          das Recht auf unentgeltliche Auskunft über Ihre gespeicherten
          personenbezogenen Daten, deren Herkunft und Empfänger und den Zweck
          der Datenverarbeitung und ggf. ein Recht auf Berichtigung, Sperrung
          oder Löschung dieser Daten. Hierzu sowie zu weiteren Fragen zum Thema
          personenbezogene Daten können Sie sich jederzeit unter der im
          Impressum angegebenen Adresse an uns wenden.
        </p>

        <h2 style={{ marginTop: '2em', marginBottom: '1em' }}>
          2. HAFTUNGSAUSSCHLUSS
        </h2>

        <h3 style={{ marginTop: '0.5em', marginBottom: '1em' }}>
          2.1 HAFTUNG FÜR INHALTE
        </h3>

        <p>
          Die Inhalte meiner Seiten wurden mit größter Sorgfalt erstellt. Für
          die Richtigkeit, Vollständigkeit und Aktualität der Inhalte kann ich
          jedoch keine Gewähr übernehmen. Als Diensteanbieter bin ich gemäß § 7
          Abs.1 TMG für eigene Inhalte auf diesen Seiten nach den allgemeinen
          Gesetzen verantwortlich. Nach §§ 8 bis 10 TMG bin ich als
          Diensteanbieter jedoch nicht verpflichtet, übermittelte oder
          gespeicherte fremde Informationen zu überwachen oder nach Umständen zu
          forschen, die auf eine rechtswidrige Tätigkeit hinweisen.
          Verpflichtungen zur Entfernung oder Sperrung der Nutzung von
          Informationen nach den allgemeinen Gesetzen bleiben hiervon unberührt.
          Eine diesbezügliche Haftung ist jedoch erst ab dem Zeitpunkt der
          Kenntnis einer konkreten Rechtsverletzung möglich. Bei Bekanntwerden
          von entsprechenden Rechtsverletzungen werden wir diese Inhalte
          umgehend entfernen.
        </p>

        <h3 style={{ marginTop: '2em', marginBottom: '1em' }}>
          2.2 HAFTUNG FÜR LINKS
        </h3>

        <p>
          Mein Angebot enthält Links zu externen Webseiten Dritter, auf deren
          Inhalte ich keinen Einfluss habe. Deshalb kann ich für diese fremden
          Inhalte auch keine Gewähr übernehmen. Für die Inhalte der verlinkten
          Seiten ist stets der jeweilige Anbieter oder Betreiber der Seiten
          verantwortlich. Die verlinkten Seiten wurden zum Zeitpunkt der
          Verlinkung auf mögliche Rechtsverstöße überprüft. Rechtswidrige
          Inhalte waren zum Zeitpunkt der Verlinkung nicht erkennbar. Eine
          permanente inhaltliche Kontrolle der verlinkten Seiten ist jedoch ohne
          konkrete Anhaltspunkte einer Rechtsverletzung nicht zumutbar. Bei
          Bekanntwerden von Rechtsverletzungen werde ich derartige Links
          umgehend entfernen.
        </p>
      </div>
    </Container>
  );
};
export default DataPrivacy;
